import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthInterceptor } from '@app/authentication/auth-interceptor';
import { DirectivesModule } from '@app/modules/directives.module';
import { UserSwitcherModule } from '@app/modules/user-switcher/user-switcher.module';
import { IonicModule } from '@ionic/angular';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    IonicModule,
    DirectivesModule,
    UserSwitcherModule
  ],
  declarations: [FullComponent, BlankComponent],
  exports: [FullComponent, BlankComponent],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ]
})
export class SharedModule {}
